var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiselectCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 0H2.66667C1.2 0 0 1.2 0 2.66667V21.3333C0 22.8 1.2 24 2.66667 24H21.3333C22.8 24 24 22.8 24 21.3333V2.66667C24 1.2 22.8 0 21.3333 0Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 1,
    fill: "#E6E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5314 6.47928C20.1562 7.11832 20.1562 8.15441 19.5314 8.79345L10.998 17.5207C10.3732 18.1598 9.36013 18.1598 8.7353 17.5207L4.46863 13.1571C3.84379 12.518 3.84379 11.482 4.46863 10.8429C5.09347 10.2039 6.10653 10.2039 6.73137 10.8429L9.86667 14.0495L17.2686 6.47928C17.8935 5.84024 18.9065 5.84024 19.5314 6.47928Z",
    fill: "#7477B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectCheckboxChecked);
export default __webpack_public_path__ + "static/media/multiselect_checkbox_checked.789ae6d6.svg";
export { ForwardRef as ReactComponent };